import BucksSVG from "@design-system/ui-icons/vanilla/Bucks"
import { createIcon } from "../createIcon"

export const BucksIcon = createIcon(BucksSVG)
